import { useEffect, useState } from "react";
import { ops, asList, fmtDate, OPS } from "@/admin/api";
import { PageTitle, EmptyState, Pill, Table, cell } from "@/admin/ui";

export default function Support() {
  const [requests, setRequests] = useState(null);
  const [deletions, setDeletions] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    ops(OPS.support).then((d) => setRequests(asList(d, "requests", "tickets"))).catch((e) => setErrors((x) => ({ ...x, support: e.message })));
    ops(OPS.deletions).then((d) => setDeletions(asList(d, "requests", "deletions"))).catch((e) => setErrors((x) => ({ ...x, deletions: e.message })));
  }, []);

  return (
    <div data-testid="admin-support-page">
      <PageTitle eyebrow="Admin Portal" title="Support" />

      <h2 className="label-tech text-neutral-500">Contact support requests</h2>
      <div className="mt-4">
        {!requests ? (
          errors.support ? <EmptyState title="Support inbox unavailable" hint={errors.support} /> : <p className="label-tech text-neutral-500">Loading…</p>
        ) : !requests.length ? (
          <EmptyState title="No support requests" hint="Contact requests submitted from the app will appear here." />
        ) : (
          <Table head={["From", "Subject", "Message", "Received", "Status"]} testId="support-table">
            {requests.map((r, i) => (
              <tr key={r.id || i} data-testid={`support-row-${r.id || i}`}>
                <td className={cell}>{r.email || r.userId || "—"}</td>
                <td className={`${cell} font-semibold text-white`}>{r.subject || r.category || "—"}</td>
                <td className={`${cell} max-w-xs truncate`}>{r.message || "—"}</td>
                <td className={cell}>{fmtDate(r.createdAt)}</td>
                <td className={cell}><Pill tone={r.status === "resolved" ? "green" : "amber"}>{r.status || "open"}</Pill></td>
              </tr>
            ))}
          </Table>
        )}
      </div>

      <h2 className="label-tech mt-12 text-neutral-500">Account deletion requests log</h2>
      <div className="mt-4">
        {!deletions ? (
          errors.deletions ? <EmptyState title="Deletion log unavailable" hint={errors.deletions} /> : <p className="label-tech text-neutral-500">Loading…</p>
        ) : !deletions.length ? (
          <EmptyState title="No deletion requests" hint="Requests from /manage-data and in-app deletions will be logged here." />
        ) : (
          <Table head={["Email", "Requested", "Status", "Note"]} testId="support-deletions-table">
            {deletions.map((d, i) => (
              <tr key={d.id || i} data-testid={`support-deletion-row-${d.id || i}`}>
                <td className={cell}>{d.email || "—"}</td>
                <td className={cell}>{fmtDate(d.createdAt || d.requestedAt)}</td>
                <td className={cell}><Pill tone={d.status === "completed" ? "green" : "amber"}>{d.status || "pending"}</Pill></td>
                <td className={cell}>{d.note || "—"}</td>
              </tr>
            ))}
          </Table>
        )}
      </div>
    </div>
  );
}
